import { NgModule } from "@angular/core";

const MATERIAL = []

@NgModule({
  declarations: [],
  imports: [MATERIAL],
  exports: [MATERIAL]
})
export class MaterialModule { }